import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import remarkBreaks from 'remark-breaks';
import { defaultRehypePlugins } from 'streamdown';
import type { MarkdownRehypePlugins } from '../Markdown/markdown.types';

export const RICH_TEXT_LARGE_HEADING_LEVEL = 2 as const;
export const RICH_TEXT_MEDIUM_HEADING_LEVEL = 3 as const;

export const RICH_TEXT_HEADING_LEVELS = [
  RICH_TEXT_LARGE_HEADING_LEVEL,
  RICH_TEXT_MEDIUM_HEADING_LEVEL,
];

export const RICH_TEXT_UNSUPPORTED_LARGE_HEADING_LEVELS = [1];
export const RICH_TEXT_UNSUPPORTED_MEDIUM_HEADING_LEVELS = [4, 5, 6];

export const RICH_TEXT_UNDERLINE_TAG = 'ins';

export const RICH_TEXT_SIZE_TAG = 'span';
export const RICH_TEXT_SIZE_ATTRIBUTE = 'data-size';
const RICH_TEXT_SIZE_HAST_PROPERTY = 'dataSize';
export const RICH_TEXT_MEDIUM_SIZE = 'medium';
export const RICH_TEXT_LARGE_SIZE = 'large';

export const RICH_TEXT_SIZES = [RICH_TEXT_MEDIUM_SIZE, RICH_TEXT_LARGE_SIZE];

export const RICH_TEXT_SUPPORTED_HTML_TAGS = [
  'a',
  'b',
  'br',
  'del',
  'div',
  'em',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'i',
  'img',
  RICH_TEXT_UNDERLINE_TAG,
  'li',
  'ol',
  'p',
  's',
  RICH_TEXT_SIZE_TAG,
  'strong',
  'sub',
  'sup',
  'ul',
];

const RICH_TEXT_SANITIZE_SCHEMA = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    [RICH_TEXT_SIZE_TAG]: [
      ...(defaultSchema.attributes?.[RICH_TEXT_SIZE_TAG] ?? []),
      [RICH_TEXT_SIZE_HAST_PROPERTY, ...RICH_TEXT_SIZES],
    ],
  },
};

export const RICH_TEXT_REHYPE_PLUGINS: MarkdownRehypePlugins = [
  defaultRehypePlugins.raw,
  [rehypeSanitize, RICH_TEXT_SANITIZE_SCHEMA],
  defaultRehypePlugins.harden,
];

export const RICH_TEXT_REMARK_PLUGINS = [remarkBreaks];
